import graphqlClient from '~/graphql/graphqlClient';

export type CavernsTravelResult = {
  caverns_data?: any;
  new_caverns_level: number;
  new_room: any;
  all_units_array: any[];
  initial_mobs: any[];
  gold: number;
  pd: number;
  items: any[];
};

const mutation = `
mutation CavernsTravel(
  $playerId: String!
  $game_submode: String!
  $direction: String!
  $survivingWhiteUnits: [JSON!]!
) {
  cavernsTravel(
    playerId: $playerId
    game_submode: $game_submode
    direction: $direction
    survivingWhiteUnits: $survivingWhiteUnits
  ) {
    caverns_data
    new_caverns_level
    new_room
    all_units_array
    initial_mobs
    gold
    pd
    items
  }
}`;

export default async function mutationCavernsTravel(args: {
  playerId: string;
  game_submode: string;
  direction: string;
  survivingWhiteUnits: any[];
}) {
  return await graphqlClient.request<CavernsTravelResult>('cavernsTravel', mutation, args);
}


